import { type ReactNode, useState } from 'react';

interface IConfirmationModal {
  title?: string;
  isOpen: boolean;
  centered?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  message?: string | ReactNode;
  cancelColor?: 'destructive' | 'neutral';
  confirmColor?: 'destructive' | 'neutral';
}

export type UseConfirmation = IConfirmationModal & {
  confirm: (
    message: ReactNode,
    onSubmit: () => void,
    title?: string,
    props?: Pick<
      IConfirmationModal,
      'centered' | 'cancelColor' | 'confirmColor'
    >,
  ) => void;
};

export const useConfirmation = (): UseConfirmation => {
  const [state, setState] = useState<IConfirmationModal>({
    isOpen: false,
    onSubmit: () => {},
    onClose: () => setState((prev) => ({ ...prev, isOpen: false })),
  });

  const confirm: UseConfirmation['confirm'] = (
    message,
    onSubmit,
    title,
    props,
  ) =>
    setState((prev) => ({
      ...prev,
      ...props,
      title,
      message,
      isOpen: true,
      onClose: () => setState((s) => ({ ...s, isOpen: false })),
      onSubmit: () => (onSubmit(), setState((s) => ({ ...s, isOpen: false }))),
    }));

  return { ...state, confirm };
};
